import React, { useEffect, useState } from 'react';
import TermLengths from './FullUWCoverageLengths';
import AboutData from './AboutData';
import ProductSpecificationsData from './ProductSpecificationsData';
import MarketingData from './MarketingData';
import PurchasingProcessData from './PurchasingProcessData';
import FaqData from './FaqData';
import PreQuote from '../../../../Quoters/PreQuote/PreQuote';
import IsHavenCampaign from './HavenCampaign';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../../sessionStorage';
import AboutMeForm from '../../../../Quoters/MCT/steps/AboutMeForm';

export default function TermData(props) {
  const [primaryBrandColor, setPrimaryBrandColor] = useState(null);

  const minAge = 18;
  const maxAge = 70;
  const minCoverageAmount = 100000;
  const maxCoverageAmount = 10000000;

  const isHavenCampaign = IsHavenCampaign();

  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  
  var accountProductTypeSettings = props ? accountObj.accountProducts.find(product => product.productLandingUrl === props.history.location.pathname) : null;
  var accountLandingOverride = accountObj.accountOverrides && accountProductTypeSettings ? 
    accountObj.accountOverrides.find(override => override.accountProductTypeId === accountProductTypeSettings.productTypeId) : null;

  useEffect(() => {
    if (!accountObj.accountOverrides) {
      setPrimaryBrandColor(accountObj.account.primaryColor);
    } else {
      setPrimaryBrandColor(accountObj.accountOverrides.primaryColor);
    }
  }, []);

  const mctForm = <AboutMeForm
    ageSpecs={{min: minAge, max: maxAge}}
    onNext={() => {
      props.history.push('/quote/term-life-insurance/multi-carrier-term/pre-quote');
    }}
    brandTheme={primaryBrandColor}
    showHeader={false}
    submitButtonVariant={'landing'}
  />

  const defaultValueProposition = [{
    title: "Term Life Insurance",
    subtitle: "Click. Quote. Coverage.",
    subtitleExtended: ""
  }]

  return {
    name: 'Term Life Insurance',
    subtitle: 'Click. Quote. Coverage.',
    footerMessage: "Get term insurance from start to finish completely online.",
    heroText: accountLandingOverride ? JSON.parse(accountLandingOverride.valueProposition) : defaultValueProposition,
    specs: {
      age: {min: minAge, max: maxAge},
      coverageAmount: {min: minCoverageAmount, max: maxCoverageAmount},
    },
    basicInfoForm: (history) => {
      return isHavenCampaign ? <PreQuote HavenCampaign landing history={history}/> : mctForm;
    },
    about: AboutData(),
    productSpecifications: ProductSpecificationsData(minAge, maxAge, minCoverageAmount, maxCoverageAmount, TermLengths()),
    marketing: MarketingData(),
    purchasingProcess: PurchasingProcessData(),
    articleKeys: [1, 2, 3],
    faq: FaqData()
  }
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Term/TermData.js